

import FooterRelative from '../components/FooterRelative';
import MiniModel from '../components/MiniModel';

const Contact = () =>{
    return(
        <div class="pageWrapper">
        <div className='contact'>
            <div className="contactForm">
            <form action="https://formsubmit.co/raphaelalc02@gmail.com" method="POST">
                <div className="formHeader"> 
                    <MiniModel />
                    <h2>Contact</h2>
                </div>
                    <input type="text" name="firstname" placeholder="Prénom" required/>
                    <input type="text" name="lastname" placeholder="Nom" required/>
                    <input type="email" name="email" placeholder="Email" required/>
                    <textarea name="message" placeholder="Message" required></textarea>
                    <input type="submit" value="Envoyer le formulaire"/>
                 </form>
            </div>
            </div>
            <FooterRelative/>
         
        </div>
        )
}
export default Contact;